module.exports = __webpack_public_path__ + "img/1Pro3-1@2x.8f957b1f.png";